import { render, staticRenderFns } from "./AddEvent.vue?vue&type=template&id=aa167724&scoped=true&"
import script from "./AddEvent.vue?vue&type=script&lang=js&"
export * from "./AddEvent.vue?vue&type=script&lang=js&"
import style0 from "./AddEvent.vue?vue&type=style&index=0&id=aa167724&prod&lang=css&"
import style1 from "./AddEvent.vue?vue&type=style&index=1&id=aa167724&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa167724",
  null
  
)

export default component.exports